import React, { useEffect, useState } from 'react';
import httpCommon from '../../../http-common';
import { MenuItem, Select } from '@mui/material';

const AnalystDropdown = ({
  id,
  field,
  row,
  rowNode,
  colDef,
  cellMode,
  hasFocus,
  tabIndex,
  value,
  formattedValue,
  isEditable,
  api
}) => {
  const [analysts, setAnalysts] = useState([]);
  const get_skilled_analysts = async () => {
    const { test_name } = row;
    const response = await httpCommon.get(`/v1/qc/get_analyst_for_test?test_id=${encodeURIComponent(test_name)}`);
    const result = response.data;
    console.log(result);
    setAnalysts(result.skilled_analysts);
    return result;
  };
  const [selected_analyst, set_selected_analyst] = useState(row.analyst_id);
  useEffect(() => {
    get_skilled_analysts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      {
        !isEditable ? selected_analyst :
          (analysts && analysts.length > 0 ?
            <Select
              id={`${id}`}
              value={selected_analyst}
              label="Analyst ID"
              size='small'
              onChange={
                async (e) => {
                  set_selected_analyst(e.target.value);
                  // const { batch_no: batch_number, test_name, stp_id } = row;
                  // const response = await edit_schedule_api({ batch_number, test_name, stp_id, analyst_id: e.target.value });
                  // if (response.status) {
                  api.updateRows([{ id, analyst_id: e.target.value }]);
                  // }
                  // else {
                  //   alert(response.message);
                  // }
                  // row.analyst_id = e.target.value;
                }
              }
            >
              {
                analysts.map((analyst) => (
                  <MenuItem key={`${id}-${analyst}`} value={analyst}>
                    {analyst}
                  </MenuItem>
                ))
              }
            </Select>
            :
            selected_analyst)
      }
    </div>
  );
};

export default AnalystDropdown;